webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(44);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _VueNoiseGeneratorPlugin = __webpack_require__(12);
	
	var _VueNoiseGeneratorPlugin2 = _interopRequireDefault(_VueNoiseGeneratorPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_VueNoiseGeneratorPlugin2.default);
	
	_vue2.default.filter('uppercase', function (key) {
	  return key.toUpperCase();
	});
	
	_vue2.default.filter('leftpad', function (value) {
	  if (value >= 10) {
	    return value;
	  }
	  return '0' + value;
	});
	
	_vue2.default.filter('addspace', function (value) {
	  return value + ' ';
	});
	
	new _vue2.default({
	  el: 'app',
	  components: { App: _App2.default },
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var workingTime =  false ? 0.1 * 60 : 5 * 60;
	var WORKING_TIME = exports.WORKING_TIME = workingTime;
	var RESTING_TIME = exports.RESTING_TIME = 5 * 60;
	var KITTEN_TIME = exports.KITTEN_TIME = 5;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START = exports.START = 'START';
	var PAUSE = exports.PAUSE = 'PAUSE';
	var STOP = exports.STOP = 'STOP';
	var TOGGLE_SOUND = exports.TOGGLE_SOUND = 'TOGGLE_SOUND';

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(11);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioContext, bufferSize, noise;
	
	audioContext = {
	  resume: function resume() {},
	  suspend: function suspend() {},
	  fake: true
	};
	
	if (window.AudioContext || window.webkitAudioContext) {
	  audioContext = new (window.AudioContext || window.webkitAudioContext)();
	}
	
	function generateWhiteNoise() {
	  var noiseBuffer, output;
	
	  bufferSize = 2 * audioContext.sampleRate;
	  noiseBuffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
	
	  output = noiseBuffer.getChannelData(0);
	  _underscore2.default.times(bufferSize, function (i) {
	    output[i] = Math.random() * 2 - 1;
	  });
	
	  noise = audioContext.createBufferSource();
	  noise.buffer = noiseBuffer;
	  noise.loop = true;
	  noise.start(0);
	
	  return noise;
	}
	
	function generatePinkNoise() {
	  bufferSize = 4096;
	  noise = function () {
	    var b0, b1, b2, b3, b4, b5, b6, node;
	    b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;
	    node = audioContext.createScriptProcessor(bufferSize, 1, 1);
	    node.onaudioprocess = function (e) {
	      var output;
	
	      output = e.outputBuffer.getChannelData(0);
	      _underscore2.default.times(bufferSize, function (i) {
	        var white = Math.random() * 2 - 1;
	        b0 = 0.99886 * b0 + white * 0.0555179;
	        b1 = 0.99332 * b1 + white * 0.0750759;
	        b2 = 0.96900 * b2 + white * 0.1538520;
	        b3 = 0.86650 * b3 + white * 0.3104856;
	        b4 = 0.55000 * b4 + white * 0.5329522;
	        b5 = -0.7616 * b5 - white * 0.0168980;
	        output[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
	        output[i] *= 0.11;
	        b6 = white * 0.115926;
	      });
	    };
	    return node;
	  }();
	
	  return noise;
	}
	
	function generateBrownNoise() {
	  bufferSize = 4096;
	
	  noise = function () {
	    var lastOut, node;
	
	    lastOut = 0.0;
	    node = audioContext.createScriptProcessor(bufferSize, 1, 1);
	    node.onaudioprocess = function (e) {
	      var output = e.outputBuffer.getChannelData(0);
	      _underscore2.default.times(bufferSize, function (i) {
	        var white = Math.random() * 2 - 1;
	        output[i] = (lastOut + 0.02 * white) / 1.02;
	        lastOut = output[i];
	        output[i] *= 3.5;
	      });
	    };
	    return node;
	  }();
	
	  return noise;
	}
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.directive('noise', function (value) {
	      var noise;
	
	      if (audioContext.fake) {
	        return;
	      }
	      switch (value) {
	        case 'white':
	          noise = generateWhiteNoise();
	          break;
	        case 'pink':
	          noise = generatePinkNoise();
	          break;
	        case 'brown':
	          noise = generateBrownNoise();
	          break;
	        default:
	          noise = generateWhiteNoise();
	      }
	      noise.connect(audioContext.destination);
	      audioContext.suspend();
	    });
	    Vue.noise = {
	      start: function start() {
	        audioContext.resume();
	      },
	      pause: function pause() {
	        audioContext.suspend();
	      },
	      stop: function stop() {
	        audioContext.suspend();
	      }
	    };
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutation_types = __webpack_require__(6);
	
	var types = _interopRequireWildcard(_mutation_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  start: function start(_ref) {
	    var commit = _ref.commit;
	
	    commit(types.START);
	  },
	  pause: function pause(_ref2) {
	    var commit = _ref2.commit;
	
	    commit(types.PAUSE);
	  },
	  stop: function stop(_ref3) {
	    var commit = _ref3.commit;
	
	    commit(types.STOP);
	  },
	  toggleSound: function toggleSound(_ref4) {
	    var commit = _ref4.commit;
	
	    commit(types.TOGGLE_SOUND);
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isStarted: function isStarted(state) {
	    return state.started;
	  },
	  isPaused: function isPaused(state) {
	    return state.paused;
	  },
	  isStopped: function isStopped(state) {
	    return state.stopped;
	  },
	  isWorking: function isWorking(state) {
	    return state.isWorking;
	  },
	  getMinutes: function getMinutes(state) {
	    return Math.floor(state.counter / 60);
	  },
	  getSeconds: function getSeconds(state) {
	    return state.counter % 60;
	  },
	  getTimestamp: function getTimestamp(state) {
	    return state.timestamp;
	  },
	  isSoundEnabled: function isSoundEnabled(state) {
	    return state.soundEnabled;
	  }
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(23);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types$START$types$PA;
	
	var _mutation_types = __webpack_require__(6);
	
	var types = _interopRequireWildcard(_mutation_types);
	
	var _underscore = __webpack_require__(11);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _config = __webpack_require__(5);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function togglePomodoro(state, toggle) {
	  if (_underscore2.default.isBoolean(toggle) === false) {
	    toggle = !state.isWorking;
	  }
	  state.isWorking = toggle;
	  if (state.isWorking) {
	    _vue2.default.noise.start();
	  } else {
	    _vue2.default.noise.pause();
	  }
	  state.counter = state.isWorking ? _config.WORKING_TIME : _config.RESTING_TIME;
	}
	
	function tick(state) {
	  if (state.counter === 0) {
	    togglePomodoro(state);
	  }
	  state.counter--;
	  if (state.counter % _config.KITTEN_TIME === 0) {
	    state.timestamp = new Date().getTime();
	  }
	}
	
	exports.default = (_types$START$types$PA = {}, (0, _defineProperty3.default)(_types$START$types$PA, types.START, function (state) {
	  state.started = true;
	  state.paused = false;
	  state.stopped = false;
	  state.interval = setInterval(function () {
	    return tick(state);
	  }, 1000);
	  if (state.isWorking && state.soundEnabled) {
	    _vue2.default.noise.start();
	  }
	}), (0, _defineProperty3.default)(_types$START$types$PA, types.PAUSE, function (state) {
	  state.paused = true;
	  state.started = true;
	  state.stopped = false;
	  clearInterval(state.interval);
	  _vue2.default.noise.pause();
	}), (0, _defineProperty3.default)(_types$START$types$PA, types.STOP, function (state) {
	  state.stopped = true;
	  state.paused = false;
	  state.started = false;
	  togglePomodoro(state, true);
	  _vue2.default.noise.stop();
	}), (0, _defineProperty3.default)(_types$START$types$PA, types.TOGGLE_SOUND, function (state) {
	  state.soundEnabled = !state.soundEnabled;
	  if (state.soundEnabled) {
	    _vue2.default.noise.start();
	  } else {
	    _vue2.default.noise.pause();
	  }
	}), _types$START$types$PA);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _getters = __webpack_require__(14);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _actions = __webpack_require__(13);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(15);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _config = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  started: false,
	  paused: false,
	  stopped: false,
	  isWorking: true,
	  counter: _config.WORKING_TIME,
	  interval: null,
	  timestamp: 0,
	  soundEnabled: true
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: _mutations2.default,
	  getters: _getters2.default,
	  actions: _actions2.default
	});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ControlsComponent = __webpack_require__(45);
	
	var _ControlsComponent2 = _interopRequireDefault(_ControlsComponent);
	
	var _CountdownComponent = __webpack_require__(46);
	
	var _CountdownComponent2 = _interopRequireDefault(_CountdownComponent);
	
	var _KittensComponent = __webpack_require__(47);
	
	var _KittensComponent2 = _interopRequireDefault(_KittensComponent);
	
	var _StateTitleComponent = __webpack_require__(48);
	
	var _StateTitleComponent2 = _interopRequireDefault(_StateTitleComponent);
	
	var _store = __webpack_require__(16);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ControlsComponent: _ControlsComponent2.default,
	    CountdownComponent: _CountdownComponent2.default,
	    KittensComponent: _KittensComponent2.default,
	    StateTitleComponent: _StateTitleComponent2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    isworking: 'isWorking'
	  }),
	  store: _store2.default
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)(['isStarted', 'isPaused', 'isStopped', 'isWorking', 'isSoundEnabled']),
	  methods: (0, _vuex.mapActions)(['start', 'stop', 'pause', 'toggleSound'])
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    min: 'getMinutes',
	    sec: 'getSeconds'
	  })
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    catimgsrc: function catimgsrc() {
	      return 'http://thecatapi.com/api/images/get?size=med&ts=' + this.$store.getters.getTimestamp;
	    }
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  data: function data() {
	    return {
	      workingtitle: 'Work!',
	      restingtitle: 'Rest!'
	    };
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    isworking: 'isWorking'
	  })
	};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(40)
	
	/* script */
	__vue_exports__ = __webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f1cfde7"
	
	module.exports = __vue_exports__


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(37)
	
	/* script */
	__vue_exports__ = __webpack_require__(18)
	
	/* template */
	var __vue_template__ = __webpack_require__(50)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-48f1dd98"
	
	module.exports = __vue_exports__


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(36)
	
	/* script */
	__vue_exports__ = __webpack_require__(19)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0600d9eb"
	
	module.exports = __vue_exports__


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(38)
	
	/* script */
	__vue_exports__ = __webpack_require__(20)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-598adc20"
	
	module.exports = __vue_exports__


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(39)
	
	/* script */
	__vue_exports__ = __webpack_require__(21)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ba8d567"
	
	module.exports = __vue_exports__


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "well"
	  }, [_c('div', {
	    staticClass: "pomodoro-timer"
	  }, [_c('span', [_vm._v(_vm._s(_vm._f("leftpad")(_vm.min)) + ":" + _vm._s(_vm._f("leftpad")(_vm.sec)))])])])
	},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('button', {
	    attrs: {
	      "title": "start",
	      "disabled": _vm.isStarted && !_vm.isPaused
	    },
	    on: {
	      "click": _vm.start
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-play"
	  })]), _vm._v(" "), _c('button', {
	    attrs: {
	      "title": "pause",
	      "disabled": !_vm.isStarted || _vm.isPaused
	    },
	    on: {
	      "click": _vm.pause
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-pause"
	  })]), _vm._v(" "), _c('button', {
	    attrs: {
	      "title": "stop",
	      "disabled": !_vm.isStarted
	    },
	    on: {
	      "click": _vm.stop
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-stop"
	  })]), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isStarted && !_vm.isPaused && _vm.isWorking),
	      expression: "isStarted && !isPaused && isWorking"
	    }],
	    staticClass: "toggle-volume glyphicon",
	    class: {
	      'glyphicon-volume-off': _vm.isSoundEnabled,
	      'glyphicon-volume-up': !_vm.isSoundEnabled
	    },
	    on: {
	      "click": _vm.toggleSound
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "well kittens"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.catimgsrc
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("\n    " + _vm._s(_vm.isworking ? _vm.workingtitle : _vm.restingtitle) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "noise",
	      rawName: "v-noise",
	      value: ('brown'),
	      expression: "'brown'"
	    }],
	    staticClass: "container",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('h2', [_c('span', [_vm._v(_vm._s(_vm._f("addspace")(_vm._f("uppercase")('Jelil Info Pomodoro'))))]), _vm._v(" "), _c('controls-component')], 1), _vm._v(" "), _c('state-title-component', {
	    attrs: {
	      "isworking": _vm.isworking
	    }
	  }), _vm._v(" "), _c('countdown-component'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('kittens-component', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isworking),
	      expression: "!isworking"
	    }]
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.ca10a965626cf3574f59.js